/** Ensures that specified url starts with a slash (/) character. */
export function ensureLeadingSlash(url: string) {
    if (!url) {
        url = '/';
    } else if (!url.startsWith('/')) {
        url = '/' + url;
    }

    return url;
}

export function ensureTrailingSlash(url: string) {
    if (!url) {
        return '/';
    }
    if (!url.endsWith('/')) {
        return url + '/';
    }
    return url;
}

export function ensureSlash(options: { url: string; leading?: boolean; trailing?: boolean }) {
    let { url } = options;

    if (options.leading) {
        url = ensureLeadingSlash(url);
    }

    if (options.trailing) {
        url = ensureTrailingSlash(url);
    }

    return url;
}
